(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        
        //for sticky header top distance
        let headerLogoEle = this.header.querySelector('sticky-header > header');
        if(headerLogoEle){
          let eleHeight = headerLogoEle.offsetHeight;
          document.querySelector('.shopify-section-header-sticky').style.top = `-${eleHeight}px;`
        }
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-register"]) return;
  try {
    

    const create_customer_form = document.querySelector('form#create_customer');
  if (create_customer_form) {
    const submitBtn = create_customer_form.querySelector('[data-form-submit]');
    if (submitBtn) {
      submitBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        registerValidateForm(create_customer_form);
      });
    }
  }

  function registerSetFieldError(field, hasError) {
    const group = field.closest('.field-grp');
    const msg = group ? group.querySelector('.form_error_message') : null;
    if (group) group.classList.toggle('error-active', hasError);
    if (msg && !msg.id) msg.id = field.id + '-client-error';

    let ids = (field.getAttribute('aria-describedby') || '').split(' ').filter(Boolean);
    if (msg) ids = ids.filter(id => id !== msg.id);

    if (hasError) {
      field.setAttribute('aria-invalid', 'true');
      if (msg) ids.push(msg.id);
    } else {
      field.removeAttribute('aria-invalid');
    }

    ids.length ? field.setAttribute('aria-describedby', ids.join(' ')) : field.removeAttribute('aria-describedby');
  }

  function registerValidateForm(form) {
    if (!form) return false;
    const emailRe = /^[a-zA-Z0-9._#%+\-!$&'*\/=?^`{|}~]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const pw = form.querySelector('#RegisterForm-password');
    const cpw = form.querySelector('#RegisterForm-confirm-password');
    let firstInvalid = null;

    form.querySelectorAll('input[required]').forEach(field => {
      const value = field.value.trim();
      let invalid = !value.length;
      if (!invalid && field.type === 'email') invalid = !emailRe.test(value);
      if (!invalid && field === cpw) invalid = !!pw && pw.value.trim() !== value;
      registerSetFieldError(field, invalid);
      if (invalid && !firstInvalid) firstInvalid = field;
    });

    if (firstInvalid) {
      firstInvalid.focus();
      return false;
    }
    form.submit();
  }

  } catch(e) { console.error(e); }
})();
})();
